import {message} from 'antd'

export const copySpecDescription = () => () => {
    return async function (nodes) {
        if (0 === nodes.length) {
            return
        }

        const [node] = nodes

        //const lsiInput = (() => {
            //for (const n of node.children) {
                //if ('LSI_INPUT' === n.data.bizNodeType) {
                    //return n
                //}
            //}
        //})()

        //const descriptions = []

        //for (const n of lsiInput.children) {
            //const {bizNodeType, arTypeCode} = n.data

            //if (
                //'AR' === bizNodeType ||
                //'EXEC' === arTypeCode
            //) {
                //const text = this.BizNode.AR.getTextRaw(this, n)
                //descriptions.push(`[${text}]`)
            //}
        //}

        const {dpSn, lsiName} = node.data
        const text = `\`invoke_${dpSn}_${lsiName}\``
        await navigator.clipboard.writeText(text)
        message.success('spec-description已复制到剪贴板')
    }
}
